import classnames from 'classnames';
import React from 'react';

/**
 * https://w3c.github.io/aria-practices/#combobox
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-select-only.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-both.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-list.html
 *
 * https://w3c.github.io/aria-practices/examples/combobox/combobox-autocomplete-none.html
 *
 * @param props BaseComboboxProps
 * @returns FunctionComponent<BaseComboboxProps>
 */ const BaseCombobox = (props)=>{
    const { className, disabled, divProps, editable, readOnly, required, textareaProps, ...otherProps } = props;
    return editable ? /*#__PURE__*/ React.createElement("textarea", {
        ...textareaProps,
        ...otherProps,
        "aria-disabled": disabled,
        "aria-haspopup": "listbox",
        "aria-readonly": readOnly,
        "aria-required": required,
        autoCapitalize: "off",
        autoComplete: "off",
        autoCorrect: "off",
        className: classnames({
            'bf-combobox': true,
            'bf-combobox__input': true,
            [`${className}`]: !!className
        }),
        disabled: disabled,
        readOnly: readOnly,
        required: required,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "combobox",
        rows: 1,
        spellCheck: false
    }) : /*#__PURE__*/ React.createElement("div", {
        ...divProps,
        ...otherProps,
        "aria-disabled": disabled,
        "aria-readonly": readOnly,
        "aria-required": required,
        "aria-haspopup": "listbox",
        className: classnames({
            'bf-combobox': true,
            'bf-combobox__div': true,
            [`${className}`]: !!className
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "combobox",
        tabIndex: 0
    });
};

export { BaseCombobox };
//# sourceMappingURL=base-combobox.js.map
